import { render, staticRenderFns } from "./CustomerActionForm.vue?vue&type=template&id=6c58b5f0&scoped=true"
import script from "./CustomerActionForm.vue?vue&type=script&lang=js"
export * from "./CustomerActionForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerActionForm.vue?vue&type=style&index=0&id=6c58b5f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c58b5f0",
  null
  
)

export default component.exports